import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Share, Plus, X } from "lucide-react";

export default function PWAInstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Check if already installed (standalone mode)
    const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                       window.navigator.standalone === true;
    setIsStandalone(standalone);

    // Show prompt for iOS users who haven't installed the app
    if (iOS && !standalone) {
      // Check if user dismissed the prompt before
      const dismissed = localStorage.getItem('pwa-prompt-dismissed');
      if (!dismissed) {
        // Show prompt after 3 seconds
        setTimeout(() => setShowPrompt(true), 3000);
      }
    }
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-dismissed', 'true');
  };

  const handleRemindLater = () => {
    setShowPrompt(false);
    // Will show again next session
  };

  if (!isIOS || isStandalone) return null;

  return (
    <Dialog open={showPrompt} onOpenChange={setShowPrompt}>
      <DialogContent 
        style={{ background: '#0A0A0A', borderColor: '#1A1A1A' }} 
        className="max-w-sm mx-4"
      >
        <DialogHeader>
          <DialogTitle 
            style={{ fontFamily: 'Bebas Neue, sans-serif', color: '#FEED00', letterSpacing: '0.05em' }}
            className="text-center text-xl"
          >
            INSTALLER L'APPLICATION
          </DialogTitle>
          <DialogDescription className="text-gray-400 text-center">
            Ajoutez Horsepower Garage CRM à votre écran d'accueil pour un accès rapide
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-4">
          {/* Step 1 */}
          <div className="flex items-start gap-3 p-3 rounded-lg" style={{ background: '#111' }}>
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: '#FEED00', color: '#000' }}
            >
              1
            </div>
            <div>
              <p className="text-white font-medium">Appuyez sur le bouton Partager</p>
              <div className="flex items-center gap-2 mt-1 text-gray-500 text-sm">
                <Share className="w-4 h-4" />
                <span>En bas de Safari</span>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex items-start gap-3 p-3 rounded-lg" style={{ background: '#111' }}>
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: '#FEED00', color: '#000' }}
            >
              2
            </div>
            <div>
              <p className="text-white font-medium">Sélectionnez "Sur l'écran d'accueil"</p>
              <div className="flex items-center gap-2 mt-1 text-gray-500 text-sm">
                <Plus className="w-4 h-4" />
                <span>Faites défiler si nécessaire</span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex items-start gap-3 p-3 rounded-lg" style={{ background: '#111' }}>
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: '#FEED00', color: '#000' }}
            >
              3
            </div>
            <div>
              <p className="text-white font-medium">Appuyez sur "Ajouter"</p>
              <p className="text-gray-500 text-sm mt-1">
                L'icône apparaîtra sur votre écran d'accueil
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <Button
            variant="outline"
            onClick={handleRemindLater}
            className="flex-1 border-gray-700 text-gray-400 hover:bg-gray-800"
          >
            Plus tard
          </Button>
          <Button
            onClick={handleDismiss}
            className="flex-1"
            style={{ background: '#FEED00', color: '#000' }}
          >
            J'ai compris
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
